module.exports = [{
      plugin: require('../node_modules/gatsby-plugin-manifest/gatsby-browser.js'),
      options: {"plugins":[],"name":"Anoop Raveendran","short_name":"anooprav7","start_url":"/","background_color":"#13293D","theme_color":"#13293D","display":"standalone","icon":"src/assets/images/code.svg","crossOrigin":"use-credentials"},
    },{
      plugin: require('../node_modules/gatsby-plugin-google-gtag/gatsby-browser.js'),
      options: {"plugins":[],"trackingIds":["UA-161868978-2"],"pluginConfig":{"head":false,"respectDNT":true}},
    }]
